/* eslint-disable no-case-declarations */
// @ts-nocheck
import { combineReducers } from "redux";
import {
  FeedFilterType,
  FeedType,
  FilteredFeedType,
  HomeBannerType,
  PostType,
  StoryBubble,
  StreakType,
  TagType,
  UserType,
} from "../types";
import {
  REMOVE_POST,
  REWARDS_USER_ACTION,
  SET_DETAIL_VIEW_POST,
  SET_FEED_DATA,
  SET_FEED_FILTER,
  SET_FEED_HOME_BANNER,
  SET_MULTI_REWARDS_DATA,
  SET_NAVBAR_FEED_FILTER,
  SET_SHOW_SEVENTH_DAY_REWARD_POPUP,
  SET_SHOW_SIMILAR_POLLS,
  SET_STORY_BUBBLES_DATA,
  SET_STREAKS_REWARD_EARNED,
  SET_USER_DATA,
  SET_USER_STREAK,
  SET_USER_TAGS,
  SET_SHOW_HOME_PAGE_ANIMATION,
  UPDATE_DETAIL_POST_FOLLOW,
  UPDATE_DETAIL_VIEW_POST,
  UPDATE_FOLLOW,
  UPDATE_KEYS_OF_POST,
} from "./type";

const initialFeedState: {
  filteredFeed: FilteredFeedType;
  navbarFeedFilters: FeedFilterType[];
  feedFilter: string;
  homeBanner: HomeBannerType;
  similarPollUuid: string;
  storyBubblesData: StoryBubble[];
} = {
  navbarFeedFilters: [],
  feedFilter: null,
  homeBanner: null,
  similarPollUuid: null,
  storyBubblesData: [],
};
const initialUserState: UserType = null;
const initialUserTags: TagType[] = [];
const initialUserStreaks: StreakType = null;
const initialDetailedPost = null;
const initialStreaksState = {
  rewardsUserAction: false,
  rewardEarned: 0,
  multiRewardsData: null,
  showSeventhDayRewardPopup: false,
  showAnimation: false,
};

function userState(state = initialUserState, action) {
  const { type, userData } = action;

  switch (type) {
    case SET_USER_DATA:
      return userData;

    default:
      return state;
  }
}

function userTags(state = initialUserTags, action) {
  const { type, userTagsData } = action;

  switch (type) {
    case SET_USER_TAGS:
      return userTagsData ?? state;

    default:
      return state;
  }
}

function userStreaks(state = initialUserStreaks, action) {
  const { type, userStreaks } = action;

  switch (type) {
    case SET_USER_STREAK:
      return userStreaks;

    default:
      return state;
  }
}

function feed(state = initialFeedState, action) {
  const {
    type,
    data,
    post,
    feedData,
    feedFilter,
    homeBanner,
    similarPostUuid,
    authorUserId,
    follow,
    navbarFeedFilters,
    storyBubbles,
    pageIndex,
    scrollPosition,
  } = action;

  switch (type) {
    case SET_FEED_DATA:
      return {
        ...state,
        filteredFeed: {
          ...state.filteredFeed,
          [feedFilter]: state?.filteredFeed?.[feedFilter]
            ? {
                ...state.filteredFeed[feedFilter],
                pageIndex,
                feed: feedData,
              }
            : {
                pageIndex,
                feed: feedData,
                scrollPosition: 0,
              },
        },
      };

    case UPDATE_KEYS_OF_POST:
      const feedPosts: FeedType[] = JSON.parse(JSON.stringify(state))
        ?.filteredFeed?.[state.feedFilter]?.feed;
      feedPosts?.forEach((p, idx) => {
        if (p?.feedData?.uuid === post?.uuid) {
          data?.forEach((e) => {
            feedPosts[idx].feedData[e.key] = e?.value;
          });
        }
        if (p?.adsData?.uuid === post?.uuid) {
          data?.forEach((e) => {
            feedPosts[idx].adsData[e.key] = e?.value;
          });
        }
      });
      return {
        ...state,
        filteredFeed: {
          ...state.filteredFeed,
          [state.feedFilter]: state?.filteredFeed?.[state?.feedFilter]
            ? {
                ...state.filteredFeed[state.feedFilter],
                feed: feedPosts,
              }
            : { pageIndex: 1, scrollPosition: 0, feed: feedPosts },
        },
      };

    case SET_NAVBAR_FEED_FILTER:
      return { ...state, navbarFeedFilters };

    case SET_FEED_FILTER:
      return state?.filteredFeed?.[state?.feedFilter]
        ? {
            ...state,
            feedFilter,
            filteredFeed: {
              ...state.filteredFeed,
              [state.feedFilter]: {
                ...state.filteredFeed[state.feedFilter],
                scrollPosition,
              },
            },
          }
        : { ...state, feedFilter };

    case SET_FEED_HOME_BANNER:
      return { ...state, homeBanner };

    case REMOVE_POST:
      let curr: FeedType[] = JSON.parse(JSON.stringify(state))?.filteredFeed?.[
        state.feedFilter
      ]?.feed;
      curr = curr.filter((e) => e?.feedData?.uuid !== post);
      curr = curr.filter((e) => e?.adsData?.uuid !== post);
      return {
        ...state,
        filteredFeed: state.filteredFeed?.[state?.feedFilter]
          ? {
              ...state.filteredFeed,
              [state.feedFilter]: {
                ...state.filteredFeed[state.feedFilter],
                feed: curr,
              },
            }
          : { pageIndex: 1, scrollPosition: 0, feed: curr },
      };

    case SET_SHOW_SIMILAR_POLLS:
      return { ...state, similarPollUuid: similarPostUuid };

    case UPDATE_FOLLOW:
      const feedCopy: FeedType[] = JSON.parse(JSON.stringify(state))
        ?.filteredFeed?.[state.feedFilter]?.feed;
      feedCopy?.forEach((e) => {
        if (e?.feedData?.author?.userId === authorUserId) {
          e.feedData.author.isFollowed = follow;
        }

        if (e?.adsData?.author?.userId === authorUserId) {
          e.adsData.author.isFollowed = follow;
        }

        e?.multipleThemeBotData?.forEach((e) => {
          if (e?.author?.userId === authorUserId) e.author.isFollowed = follow;
        });

        if (e?.themeBotData?.[0]?.author?.userId === authorUserId) {
          e?.themeBotData?.forEach((e) => {
            e.author.userId = authorUserId;
          });
        }
      });

      return {
        ...state,
        filteredFeed: {
          ...state.filteredFeed,
          [state.feedFilter]: state.filteredFeed?.[state?.feedFilter]
            ? {
                ...state.filteredFeed[state.feedFilter],
                feed: feedCopy,
              }
            : { pageIndex: 1, scrollPosition: 0, feed: feedCopy },
        },
      };

    case SET_STORY_BUBBLES_DATA:
      return { ...state, storyBubblesData: storyBubbles };

    default:
      return state;
  }
}

function detailedPost(state = initialDetailedPost, action) {
  const { type, post, data, authorUserId, follow } = action;

  switch (type) {
    case SET_DETAIL_VIEW_POST:
      return post;

    case UPDATE_DETAIL_VIEW_POST:
      const detailPostCopy = JSON.parse(JSON.stringify(state));
      data?.forEach((e) => {
        detailPostCopy[e.key] = e?.value;
      });
      return detailPostCopy;

    case UPDATE_DETAIL_POST_FOLLOW:
      const copy: PostType = JSON.parse(JSON.stringify(state));
      if (copy?.author?.userId === authorUserId) {
        copy.author.isFollowed = follow;
      }
      return copy;

    default:
      return state;
  }
}

function streaks(state = initialStreaksState, action) {
  const {
    type,
    rewardsUserAction,
    rewardEarned,
    skipUserAction,
    multiRewardsData,
    showSeventhDayRewardPopup,
    showAnimation,
  } = action;
  switch (type) {
    case REWARDS_USER_ACTION:
      return { ...state, rewardsUserAction, skipUserAction };

    case SET_STREAKS_REWARD_EARNED:
      return { ...state, rewardEarned };

    case SET_MULTI_REWARDS_DATA:
      return { ...state, multiRewardsData };

    case SET_SHOW_SEVENTH_DAY_REWARD_POPUP:
      return { ...state, showSeventhDayRewardPopup };

    case SET_SHOW_HOME_PAGE_ANIMATION:
      return { ...state, showAnimation };

    default:
      return state;
  }
}

export default function () {
  return combineReducers({
    userState,
    feed,
    detailedPost,
    userTags,
    userStreaks,
    streaks,
  });
}
